import { render, staticRenderFns } from "./CarouselContent.vue?vue&type=template&id=e18925fc&scoped=true"
import script from "./CarouselContent.vue?vue&type=script&lang=js"
export * from "./CarouselContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18925fc",
  null
  
)

export default component.exports